import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const PolicyCancellationSection = ({ data }) => {
  const newValue = data?.cancellationEffectiveDate?.newValue?.trim?.();

  if (!newValue) return null;

  return (
    <Paper
      elevation={0}
      sx={{
        border: '1px solid #d9d9d9',
        mb: 2,
        overflow: 'hidden',
        borderRadius: 0,
      }}
    >
      {/* Header */}
      <Box
        sx={{
          backgroundColor: '#5569ff',
          color: '#fff',
          px: '8px',
          py: '4px',
        }}
      >
        Cancellation Effective Date
      </Box>

      {/* Content */}
      <Box sx={{ px: 2, py: 2 }}>
        <Typography variant="body2" fontWeight="bold" gutterBottom>
          Effective Date
        </Typography>

        <Typography sx={{ color: 'error.main', fontWeight: 500 }}>
          {newValue}
        </Typography>
      </Box>
    </Paper>
  );
};

export default PolicyCancellationSection;